import React from 'react';
import { StrikeThroughHeader } from '../../../../components/Headers/strikethrough-header/strikethrough-header';
import ClientTable from './ClientTable';

const Proposal = () => {
  return (
    <>
      <StrikeThroughHeader>Proposals</StrikeThroughHeader>
      <ClientTable />
    </>
  );
};
export default Proposal;
